import { render, staticRenderFns } from "./InnerMenu.vue?vue&type=template&id=36786fea&scoped=true&"
import script from "./InnerMenu.vue?vue&type=script&lang=js&"
export * from "./InnerMenu.vue?vue&type=script&lang=js&"
import style0 from "./InnerMenu.vue?vue&type=style&index=0&id=36786fea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36786fea",
  null
  
)

export default component.exports